import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DeleteOneAddress } from '../../redux/Slices/UserSlice'
import notify from "./../UseNotification"
const UseDeleteAddressUser = (item) => {
    const dispatch = useDispatch()
    const { deleteAddress } = useSelector(state => state.UserReducer)
    const [loading, setLoading] = useState(true)
    const [deleteShow, setDeleteShow] = useState(false)


    // handle delete show 
    const handleDeleteShow = () => {
        setDeleteShow(true)
    }

    // handle delete show 
    const handleDeleteClose = () => {
        setDeleteShow(false)
    }
    // handle delete address card
    const HandleDeleteAddress = async () => {
        handleDeleteClose()
        setLoading(true)
        await dispatch(DeleteOneAddress(item._id))
        setLoading(false)
    }

    useEffect(() => {
        if (loading === false) {
            if (deleteAddress && deleteAddress.status === 200) {
                notify("address deleted", "success")
                window.location.reload(false)
            } else {
                notify("try again", "error")
            }
        }
    }, [loading])

    return [HandleDeleteAddress, handleDeleteShow, handleDeleteClose, deleteShow]
}

export default UseDeleteAddressUser
